import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { IamAuthService } from './services/iam-auth.service';
import { filter, takeUntil } from 'rxjs/operators';
import { InteractionStatus } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { MsalErrorConstants } from './constants/msal-error.constants';


@Component({
  selector: 'msal-login-redirect',
  template: ''
})
export class MsalServicesComponent  {
  private readonly _destroying$ = new Subject<void>();
  public countryConfiguration: any;
  private europeHost = window['HOST_EUROPE'];
  private americaHost = window['HOST_AMERICA'];
  private urlRoute: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private iamService: IamAuthService,
    private msalBroadcastService: MsalBroadcastService
  ) {
  }

  ngOnInit(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        sessionStorage.setItem('loginByIAM', 'true');
        this.urlRoute = this.route.snapshot.queryParams['returnUrl'] || '';

        const signinAccount = this.iamService.getSigninAccount();
        const userCountry = signinAccount.idTokenClaims['country'].toString().trim();

        this.iamService.getConfigurationParametersByCountryAll().subscribe(
          countries => {
            this.countryConfiguration = countries;
            if (this.countryConfiguration.length > 0) {
              const filteredCountry = this.countryConfiguration?.filter(countryCode => countryCode.countryCode?.trim() === userCountry);
              const userRegion = filteredCountry && filteredCountry.length > 0 ? filteredCountry[0].region : undefined;
              const regionHost = userRegion === 'EURO' ? this.europeHost : this.americaHost;

              if (regionHost != window.location.host) {
                const baseUrl = `${window.location.protocol}//${regionHost}`;
                window.location.href = `${baseUrl}${this.iamService.getPostLogoutRedirectUri()}?returnUrl=${encodeURIComponent(this.urlRoute)}`;
              } else {
                this.iamService.getUserProfile().subscribe((data) => {
                  const userInformation = this.convertData(data, userRegion);
                  this.saveProcessDataFromLogin(userInformation);
                  const destinationUrl =this.urlRoute ? this.urlRoute :  'invoices-payments/dashboard';
                  this.router.navigateByUrl(destinationUrl);

                  }, error => {
                    sessionStorage.setItem('errorLogin', MsalErrorConstants.VIEWS_LOGIN_IAM_ERROR_PROFILE);
                    this.iamService.logoutIAM();
                });
              }
            }
          },
          error => {
            sessionStorage.setItem('errorLogin', MsalErrorConstants.VIEWS_LOGIN_IAM_ERROR_CONTRY);
            this.iamService.logoutIAM();
          }
        )
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  //TODO: Use Angular Services functions
  private convertData(data: any, userRegion: string): any {
    const userInformation = {};
    const oauth2 = {
      region: userRegion
    };

    userInformation['oauth2'] = oauth2;
    const user = data.users[0];
    const profile = {
      userId: user.userId,
      customerId: user?.customer?.customerId,
      status: user.status.userStatus,
      userAccount: user.userAccount,
      fullName: user.fullName,
      firstName: user.firstName,
      lastName: user.lastName,
      phoneNumber: user.phoneNumber,
      userType: user.type.userType,
      accountType: user.account.accountType,
      userPosition: data.profile.userPosition,
      allowInformationShare: data.profile.allowInformationShare,
      allowEmailUpdates: data.profile.allowEmailUpdates,
      userSelectedId: user.userSelected.userSelectedId,
      isDigitalAdmin: user.isDigitalAdmin,
      hasTemporaryPassword: data.profile.hasTemporaryPassword,
      canChangePassword: user.canChangePassword,
      languageId: data.profile.languageId,
      cloudContactMethodId: data.profile.cloudContactMethodId ?? undefined,
      cloudContactTypeId: data.profile.cloudContactTypeId ?? undefined,
      cloudContactCode: data.profile.cloudContactCode ?? undefined,
      countryAreaCode: data.profile.countryAreaCode ?? undefined
    };
    userInformation['profile'] = profile;

    const customer = {
      customerId: user.customer?.customerId,
      customerCode: user.customer?.customerCode,
      customerDesc: user.customer?.customerDesc,
      userId: user.customer?.userId
    };

    userInformation['customer'] = !user.customer ? null : customer;
    userInformation['customerId'] = user.customer ?? 0;
    userInformation['country'] = data.users[0].country.countryCode.trim();
    userInformation['role'] = data.users[0].type.userType;

    const applications = [];
    data.applications.forEach(app => {
      const application = {
        applicationId: app.applicationId,
        applicationName: app.applicationDesc,
        applicationCode: app.applicationCode,
        applicationDesc: app.applicationDesc,
        isVisible: app.isVisible
      };

      const roles = [];
      if (data.roles != undefined && data.roles != null) {
        data.roles.filter(rol => rol.application.applicationId == app.applicationId).forEach(r => {
          const rol = {
            roleId: r.roleId,
            roleCode: r.roleCode,
            roleName: r.roleName,
            roleDesc: r.roleDesc,
            roleType: r.roleType,
            isVisible: r.isVisible
          };
          roles.push(rol);
        });
      }
      application['roles'] = roles;
      applications.push(application);
    });

    userInformation['applications'] = applications;
    return userInformation;
  }

  private saveProcessDataFromLogin(data:any){
    sessionStorage.setItem('_cmx_', this.iamService.encrypt(JSON.stringify(data)));

    //TODO: Review the region value AME or EURO instead of US or UK
    this.iamService.createCookie('CemexGoRegion', data.oauth2.region, null);

    sessionStorage.setItem('sessionId', data.profile.userId);
    sessionStorage.setItem('role', data.role);
    sessionStorage.setItem('country', data.country);
    sessionStorage.setItem('username', data.profile.userAccount);
  }
}
